
import CreateView from '@/components/CreateView';

import { XhStrucUserCell } from '@/components/CreateCom';
// API
import { noticeAddOrUpateAPI } from '@/api/oa/notice';
import { formatTimeToTimestamp } from '@/utils/index';

export default {
  components: {
    CreateView: CreateView,
    XhStrucUserCell: XhStrucUserCell
  },
  props: {
    action: {
      type: Object,
      default: function _default() {
        return {
          type: 'save'
        };
      }
    }
  },

  data: function data() {
    var _this = this;

    var validateTime = function validateTime(rule, value, callback) {
      if (rule.field == 'startTime' && !_this.formData.startTime && _this.formData.endTime || rule.field == 'endTime' && !_this.formData.endTime && _this.formData.startTime) {
        callback(new Error('请完善时间'));
      } else if (_this.formData.startTime && _this.formData.endTime) {
        if (formatTimeToTimestamp(_this.formData.startTime) >= formatTimeToTimestamp(_this.formData.endTime)) {
          callback(new Error('开始时间必须小于结束时间'));
        }
      }
      callback();
    };
    return {
      formList: [{ label: '公告标题', field: 'title' }, { label: '通知范围', field: 'dep', type: 'plus' },
      // { label: '开始时间', field: 'startTime', type: 'date' },
      // { label: '结束时间', field: 'endTime', type: 'date' },
      { label: '公告正文', field: 'content', type: 'textarea' }],
      formData: { dep: { staff: [], dep: [] } },
      rules: {
        title: [{ required: true, message: '公告标题不能为空', trigger: 'blur' }, { max: 50, message: '公告标题长度最多为50个字符', trigger: 'blur' }],
        content: [{ required: true, message: '公告正文不能为空', trigger: 'blur' }],
        startTime: [{ required: true, message: '不能为空', trigger: 'blur' }, { validator: validateTime, trigger: 'blur' }],
        endTime: [{ required: true, message: '不能为空', trigger: 'blur' }, { validator: validateTime, trigger: 'blur' }]
      },
      loading: false
    };
  },


  computed: {
    title: function title() {
      return this.action.type == 'save' ? '新建公告' : '编辑公告';
    }
  },

  created: function created() {
    if (this.action.type == 'update') {
      this.formData = {
        title: this.action.data.title,
        content: this.action.data.content,
        dep: { staff: this.action.data.ownerUserList, dep: this.action.data.structureList }
      };
    }
  },


  methods: {
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this2.loading = true;
          var params = {
            title: _this2.formData.title,
            content: _this2.formData.content,
            // startTime: this.formData.startTime,
            // endTime: this.formData.endTime,
            owner_structure_ids: _this2.formData.dep.dep && _this2.formData.dep.dep.map(function (item) {
              return item.id;
            }),

            owner_user_ids: _this2.formData.dep.staff && _this2.formData.dep.staff.map(function (item) {
              return item.id;
            })

          };

          if (_this2.action.type == 'update') {
            params.announcement_id = _this2.action.id;
          }

          noticeAddOrUpateAPI(params).then(function (res) {
            _this2.$message.success(_this2.title + '\u6210\u529F');
            // if (this.$route.query.routerKey == 1) {
            //   this.$router.push('notice')
            // } else {
            _this2.$emit('onSubmit');
            _this2.close();
            // }
            _this2.loading = false;
          }).catch(function () {
            _this2.$message.error(_this2.title + '\u5931\u8D25');
            _this2.loading = false;
          });
        } else {
          return false;
        }
      });
    },
    close: function close() {
      // if (this.$route.query.routerKey == 1) {
      //   this.$router.go(-1)
      // } else {
      this.$emit('close');
      // }
    },

    // 关闭按钮
    strcUserChange: function strcUserChange(data) {
      this.$set(this.formData, 'dep', { staff: data.value.users, dep: data.value.strucs });
    },

    // 删除部门和用户
    deleteuser: function deleteuser(index) {
      this.formData.dep.staff.splice(index, 1);
    },
    deleteDepuser: function deleteDepuser(index) {
      this.formData.dep.dep.splice(index, 1);
    }
  }
};